import BeforeLogedIn from "../../Login/BeforeLogedIn";
const LoginTab = () => {
	return (
		<div className="srb-cange-box for-top-fix-box ">
			<div className="srb-cange-box-inner changestate-box">
				<BeforeLogedIn />
			</div>
		</div>
	);
};
export default LoginTab;
